import React from "react";

const TableComponent = ({ data }) => (
    <div className="w-full">
        <table className="w-full border-collapse table-component">
            <tbody>
                {Object.entries(data).map(([key, value]) => (
                    <tr key={key} className="border-b">
                        <td className="py-2 px-4 bg-gray-100 w-1/3 font-semibold pr-12">{key}</td>
                        <td className="py-2 px-4 pl-12">{value}</td>
                    </tr>
                ))}
            </tbody>
        </table>
    </div>
);

export default TableComponent;